export enum CommonSettingsErrors {
    SETTING_IS_BLANK = 'SETTING_IS_BLANK',
    NOT_BLANK = 'NOT_BLANK',
    INVALID_VALUE_FOR_MONEY_SETTING = 'INVALID_VALUE_FOR_MONEY_SETTING',
    INVALID_VALUE_FOR_PERCENTAGE_SETTING = 'INVALID_VALUE_FOR_PERCENTAGE_SETTING',
    ORDER_SHARES_NOT_VALID = 'ORDER_SHARES_NOT_VALID'
}
